import React, { useEffect } from "react";
import styles from "./TextArea.module.css";

function useTextAreaController(props: {
  onChange: (value: string) => void;
  value: string;
  name?: string;
}): {
  value: string;
  handleChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
} {
  const [value, setValue] = React.useState(props.value);
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(event.target.value);
    props.onChange(event.target.value);
  };
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);
  return { value, handleChange };
}

export const TextArea = (props: {
  onChange: (value: string) => void;
  value: string;
  name?: string;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  onSubmit?: () => void;
}) => {
  const { value, handleChange } = useTextAreaController(props);
  return (
    <textarea
      className={styles.TextArea + " " + props.className}
      value={value}
      onChange={handleChange}
      name={props.name}
      id={props.name}
      disabled={props.disabled}
      placeholder={props.placeholder}
      onKeyDown={(e) => {
        if (props.onSubmit && e.key === "Enter" && !e.shiftKey) {
          e.preventDefault();
          props.onSubmit?.();
        }
      }}
    />
  );
};
